import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../containers/EmbroideryService'
import { EmbroiderySectionWrapper } from '../EmbroiderySectionWrapper'

import { EmbroideryPromoHeader } from './EmbroideryPromoHeader'

export type PersonalizeSectionWrapperProps = {
  children: React.ReactNode
  isPortalColorSelected?: boolean
  hasBorder?: boolean
}

export type PersonalizeSectionTextProps = {
  children: React.ReactNode
} & HTMLAttributes<HTMLDivElement>

const PersonalizeSectionWrapper = ({
  children,
  hasBorder = false,
  isPortalColorSelected = false,
}: PersonalizeSectionWrapperProps) => {
  const {
    priceRange: { lowestPrice },
  } = EmbroideryService.useContainer()
  const { embroidery: embroideryStrings } = useTranslation()

  const endAdornment = isPortalColorSelected ? `+${lowestPrice}` : undefined

  return (
    <EmbroiderySectionWrapper className='personalize-section' hasBorder={hasBorder}>
      <AttributeSection
        title={<EmbroideryPromoHeader title={embroideryStrings.title} />}
        endAdornment={endAdornment}
      >
        {children}
      </AttributeSection>
    </EmbroiderySectionWrapper>
  )
}

const PersonalizeSectionText = ({ children, ...rest }: PersonalizeSectionTextProps) => {
  return (
    <MandatoryTextAndLogoEmbroideryWrapper {...rest}>
      {children}
    </MandatoryTextAndLogoEmbroideryWrapper>
  )
}

export const PersonalizeSection = {
  Wrapper: PersonalizeSectionWrapper,
  Text: PersonalizeSectionText,
}

const MandatoryTextAndLogoEmbroideryWrapper = styled.div`
  color: ${o => o.theme.color.deprecated.obsidianLight};
`
